/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "user-small-3a036207--sprite",
  "use": "user-small-3a036207--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"user-small-3a036207--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(12 10)\"><g transform=\"translate(0 8.302)\"><path d=\"M922.45,152.318c0,1.683-2.684,3.053-6,3.053s-6-1.371-6-3.053a1.016,1.016,0,0,1,.023-.235.4.4,0,0,1,.014-.1,1.724,1.724,0,0,1,.1-.375,6.333,6.333,0,0,1,11.724,0,1.4,1.4,0,0,1,.1.393.4.4,0,0,1,.014.1A1.183,1.183,0,0,1,922.45,152.318Z\" transform=\"translate(-910.45 -147.673)\" fill=\"currentColor\" /></g><ellipse cx=\"3.251\" cy=\"3.299\" rx=\"3.251\" ry=\"3.299\" transform=\"translate(2.749)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
